import { useEffect, useState } from 'react';
import { fetchInvitationEmail } from '../../authActions';

export default (inviteCode) => {
    const [invitationEmail, setInvitationEmail] = useState(undefined);

    useEffect(() => {
        // Set initial value of email to be invitation email if inviteCode exist
        if (inviteCode) {
            fetchInvitationEmail(inviteCode).then(setInvitationEmail);
        }
    }, [inviteCode]);

    return invitationEmail;
};
